export interface FeedEvent {
  id: number;
  catKey: string;
  cat: string;
  title: string;
  excerpt: string;
  date: string;
  read: string;
  img: string;
  alt: string;
}

export const categories = [
  { key: "all", name: "全部瓜田", icon: "ri-fire-line", desc: "不分栏目，按热度混合推送全网热议事件。" },
  { key: "yule", name: "娱乐前线", icon: "ri-star-smile-line", desc: "明星动态、红毯现场与圈内新鲜事。" },
  { key: "yingshi", name: "影视热播", icon: "ri-film-line", desc: "热剧、新片、票房与剧情热议。" },
  { key: "zongyi", name: "综艺现场", icon: "ri-tv-2-line", desc: "综艺名场面、游戏规则与幕后花絮。" },
  { key: "regg", name: "互联网热梗", icon: "ri-bubble-chart-line", desc: "刷屏热梗、流行语与网络文化现象。" },
  { key: "shehui", name: "社会话题", icon: "ri-earth-line", desc: "大家都会聊到的公共话题与民生议题。" },
  { key: "keji", name: "科技新鲜事", icon: "ri-rocket-line", desc: "新发布的产品与科技圈谈资。" },
];

export const categoriesAll = [
  { key: "all", name: "全部瓜田", icon: "ri-fire-line", desc: "不分栏目，按热度混合推送全网热议事件。" },
  { key: "yule", name: "娱乐前线", icon: "ri-star-smile-line", desc: "明星动态、红毯现场与圈内新鲜事。" },
  { key: "yingshi", name: "影视热播", icon: "ri-film-line", desc: "热剧、新片、票房与剧情热议。" },
  { key: "zongyi", name: "综艺现场", icon: "ri-tv-2-line", desc: "综艺名场面、游戏规则与幕后花絮。" },
  { key: "regg", name: "互联网热梗", icon: "ri-bubble-chart-line", desc: "刷屏热梗、流行语与网络文化现象。" },
  { key: "shehui", name: "社会话题", icon: "ri-earth-line", desc: "大家都会聊到的公共话题与民生议题。" },
  { key: "keji", name: "科技新鲜事", icon: "ri-rocket-line", desc: "新发布的产品与科技圈谈资。" },
];

export const topStories = [
  {
    id: 1,
    tag: "今日炸点",
    cat: "综艺现场",
    title: "一档音综把「多年老歌」唱成全网单曲循环",
    desc: "从冷门到霸榜，一首被重新演绎的老歌如何一夜翻红，又在节目收官后继续发酵？",
    date: "09-07",
    heat: 982,
    img: "https://readdy.ai/api/search-image?query=stylized%20editorial%20illustration%20in%20warm%20coral%20red%20amber%20and%20cream%20palette%20with%20soft%20geometric%20shapes%2C%20variety%20show%20singing%20stage%20spotlight%20with%20microphone%20and%20vinyl%20records%20floating%2C%20watermelon%20melon%20motif%2C%20trending%20news%20theme%2C%20clean%20minimal%20vector%20art%2C%20no%20text&width=800&height=1000&seq=story-1-x1&orientation=portrait",
    alt: "音综老歌翻红成为今日炸点话题插画",
  },
  {
    id: 2,
    tag: "持续发酵",
    cat: "娱乐前线",
    title: "红毯造型大赏：今年谁穿出了「高光时刻」",
    desc: "红毯是大型修罗场，也是审美比拼现场。一起复盘本季最出圈的几套造型与背后的造型师团队。",
    date: "09-06",
    heat: 876,
    img: "https://readdy.ai/api/search-image?query=stylized%20editorial%20illustration%20in%20warm%20coral%20red%20amber%20and%20cream%20palette%20with%20soft%20geometric%20shapes%2C%20glamorous%20red%20carpet%20evening%20gown%20with%20camera%20flashlights%20and%20sparkle%2C%20watermelon%20melon%20motif%2C%20fashion%20entertainment%20theme%2C%20clean%20minimal%20vector%20art%2C%20no%20text&width=800&height=1000&seq=story-2-x1&orientation=portrait",
    alt: "红毯造型大赏话题插画",
  },
  {
    id: 3,
    tag: "今日炸点",
    cat: "影视热播",
    title: "这部话题剧大结局前，观众在吵些什么",
    desc: "人设、台词、结局走向都成了饭桌谈资，剧集还未收官，讨论度已冲到平台榜首。",
    date: "09-07",
    heat: 831,
    img: "https://readdy.ai/api/search-image?query=stylized%20editorial%20illustration%20in%20warm%20coral%20red%20amber%20and%20cream%20palette%20with%20soft%20geometric%20shapes%2C%20drama%20series%20tv%20screen%20with%20clapperboard%20and%20popcorn%20floating%2C%20watermelon%20melon%20motif%2C%20film%20trending%20theme%2C%20clean%20minimal%20vector%20art%2C%20no%20text&width=800&height=1000&seq=story-3-x1&orientation=portrait",
    alt: "话题剧大结局热议插画",
  },
];

export const feedEvents: FeedEvent[] = [
  {
    id: 1,
    catKey: "yule",
    cat: "娱乐前线",
    title: "久未露面的老牌歌手官宣回归舞台，巡回安排引期待",
    excerpt: "沉寂多年的老牌唱将突然放出回归预告，票价与场次安排尚未公开，评论区已先吵成一团。",
    date: "09-07",
    read: "2.1万",
    img: "https://readdy.ai/api/search-image?query=stylized%20editorial%20illustration%20in%20warm%20coral%20red%20amber%20and%20cream%20palette%2C%20veteran%20singer%20returning%20to%20stage%20with%20concert%20lights%20and%20audience%20hands%20raised%2C%20watermelon%20melon%20motif%2C%20entertainment%20news%20theme%2C%20clean%20minimal%20vector%20art%2C%20no%20text&width=600&height=460&seq=event-1-x1&orientation=landscape",
    alt: "老牌歌手回归巡演热点插画",
  },
  {
    id: 2,
    catKey: "yingshi",
    cat: "影视热播",
    title: "票房周报：暑期档之后哪部新片最能打",
    desc: "档期交接的一周，多部新片同日开画，题材各异，观众用脚投票的结果正在改写口碑榜。",
    date: "09-07",
    read: "1.6万",
    img: "https://readdy.ai/api/search-image?query=stylized%20editorial%20illustration%20in%20warm%20coral%20red%20amber%20and%20cream%20palette%2C%20cinema%20film%20reels%20and%20ticket%20stub%20box%20office%20chart%20going%20up%2C%20watermelon%20melon%20motif%2C%20movie%20box%20office%20theme%2C%20clean%20minimal%20vector%20art%2C%20no%20text&width=600&height=460&seq=event-2-x1&orientation=landscape",
    alt: "电影票房周报插画",
  },
  {
    id: 3,
    catKey: "zongyi",
    cat: "综艺现场",
    title: "慢综艺里的一场「真心话局」，把网友看破防",
    desc: "没有台本式的冲突，只有几个人围坐聊天。一段关于成长的坦白，意外成为本周最出圈片段。",
    date: "09-06",
    read: "3.4万",
    img: "https://readdy.ai/api/search-image?query=stylized%20editorial%20illustration%20in%20warm%20coral%20red%20amber%20and%20cream%20palette%2C%20cozy%20variety%20show%20sofa%20chat%20scene%20with%20moon%20and%20warm%20lamp%2C%20watermelon%20melon%20motif%2C%20slow%20variety%20show%20theme%2C%20clean%20minimal%20vector%20art%2C%20no%20text&width=600&height=460&seq=event-3-x1&orientation=landscape",
    alt: "慢综艺真心话局出圈片段插画",
  },
  {
    id: 4,
    catKey: "regg",
    cat: "互联网热梗",
    title: "又一个新的「打工人暗号」火了，你听懂了吗",
    desc: "一句看似日常的话，被网友接出了无数种解释。梗的传播速度，往往比事件本身还快。",
    date: "09-06",
    read: "5.2万",
    img: "https://readdy.ai/api/search-image?query=stylized%20editorial%20illustration%20in%20warm%20coral%20red%20amber%20and%20cream%20palette%2C%20speech%20bubbles%20and%20office%20worker%20desk%20scene%20with%20memes%20floating%2C%20watermelon%20melon%20motif%2C%20internet%20meme%20culture%20theme%2C%20clean%20minimal%20vector%20art%2C%20no%20text&width=600&height=460&seq=event-4-x1&orientation=landscape",
    alt: "互联网打工人热梗流行语插画",
  },
  {
    id: 5,
    catKey: "shehui",
    cat: "社会话题",
    title: "城市夜经济观察：凌晨三点的商圈里藏着什么",
    desc: "从夜市到二十四小时书店，越来越多城市把「夜」变成一张名片。年轻人到底在夜里寻找什么？",
    date: "09-05",
    read: "1.1万",
    img: "https://readdy.ai/api/search-image?query=stylized%20editorial%20illustration%20in%20warm%20coral%20red%20amber%20and%20cream%20palette%2C%20night%20city%20street%20with%20street%20food%20stalls%20neon%20glow%20and%20people%20walking%2C%20watermelon%20melon%20motif%2C%20night%20economy%20social%20topic%20theme%2C%20clean%20minimal%20vector%20art%2C%20no%20text&width=600&height=460&seq=event-5-x1&orientation=landscape",
    alt: "城市夜经济商圈观察插画",
  },
  {
    id: 6,
    catKey: "keji",
    cat: "科技新鲜事",
    title: "新发布的折叠屏到底值不值得冲？一篇看懂",
    desc: "厂商发布会密集，参数一个比一个卷。我们帮你把屏幕、续航与价格掰开揉碎讲清楚。",
    date: "09-05",
    read: "8900",
    img: "https://readdy.ai/api/search-image?query=stylized%20editorial%20illustration%20in%20warm%20coral%20red%20amber%20and%20cream%20palette%2C%20foldable%20smartphone%20with%20circuit%20lines%20and%20lightning%20bolt%2C%20watermelon%20melon%20motif%2C%20tech%20gadget%20theme%2C%20clean%20minimal%20vector%20art%2C%20no%20text&width=600&height=460&seq=event-6-x1&orientation=landscape",
    alt: "折叠屏手机新发布科普插画",
  },
  {
    id: 7,
    catKey: "yule",
    cat: "娱乐前线",
    title: "选秀之后再就业：那些转型做副业的艺人们",
    desc: "有人开起了买手店，有人转做幕后制作。行业降温之后，「多条腿走路」成了圈内新常态。",
    date: "09-04",
    read: "7200",
    img: "https://readdy.ai/api/search-image?query=stylized%20editorial%20illustration%20in%20warm%20coral%20red%20amber%20and%20cream%20palette%2C%20celebrity%20silhouette%20juggling%20multiple%20roles%20microphone%20camera%20and%20storefront%2C%20watermelon%20melon%20motif%2C%20entertainment%20career%20theme%2C%20clean%20minimal%20vector%20art%2C%20no%20text&width=600&height=460&seq=event-7-x1&orientation=landscape",
    alt: "艺人转型副业观察插画",
  },
  {
    id: 8,
    catKey: "regg",
    cat: "互联网热梗",
    title: "年度流行语盘点前哨：这些词已经从群聊出圈",
    desc: "还在犹豫要不要用的热词，可能已经过时。从聊天框到官方通稿，流行语的生命周期越来越短。",
    date: "09-04",
    read: "4.8万",
    img: "https://readdy.ai/api/search-image?query=stylized%20editorial%20illustration%20in%20warm%20coral%20red%20amber%20and%20cream%20palette%2C%20dictionary%20book%20with%20fire%20and%20spark%20words%20rising%20up%2C%20watermelon%20melon%20motif%2C%20popular%20words%20linguistics%20theme%2C%20clean%20minimal%20vector%20art%2C%20no%20text&width=600&height=460&seq=event-8-x1&orientation=landscape",
    alt: "年度流行语盘点插画",
  },
];

export const ranking = [
  { rank: 1, title: "音综老歌翻唱，评论区现场「考古」", heat: "982万", delta: "up", tag: "综艺" },
  { rank: 2, title: "话题剧大结局预测，网友吵出剧本", heat: "876万", delta: "up", tag: "影视" },
  { rank: 3, title: "红毯高光造型盘点出圈", heat: "831万", delta: "up", tag: "娱乐" },
  { rank: 4, title: "新流行语「暗号」全网破译", heat: "764万", delta: "up", tag: "热梗" },
  { rank: 5, title: "慢综艺真心话局刷屏", heat: "702万", delta: "flat", tag: "综艺" },
  { rank: 6, title: "折叠屏新机发布，参数有多卷", heat: "651万", delta: "flat", tag: "科技" },
  { rank: 7, title: "老牌歌手回归舞台预告", heat: "598万", delta: "down", tag: "娱乐" },
  { rank: 8, title: "夜经济观察：深夜商圈烟火气", heat: "520万", delta: "down", tag: "社会" },
  { rank: 9, title: "暑期档后的电影口碑长跑", heat: "463万", delta: "down", tag: "影视" },
  { rank: 10, title: "流行语从群聊走向官方稿", heat: "405万", delta: "up", tag: "热梗" },
];

export const faqList = [
  {
    q: "什么是今日炸点与爆点事件？",
    a: "吃瓜爆网把单日内讨论量、转发量和围观人数上升最快的热门话题标记为今日炸点，把持续发酵、信息量较大的完整事件整理为爆点事件。我们按热度动态排序，让你一页看清大家都在围观的瓜。",
  },
  {
    q: "栏目内容多久更新一次？",
    a: "娱乐、影视、综艺、热梗等栏目每日滚动更新；全网围观榜每小时刷新一次热度；爆点事件专区会对重点事件持续跟进后续进展。",
  },
  {
    q: "如何向吃瓜爆网投稿或爆料？",
    a: "欢迎通过页面底部的邮箱与我们联系，投稿时请尽量提供可核实的信息来源。我们会对线索进行二次核验，符合栏目定位的内容会尽快上线。",
  },
  {
    q: "吃瓜时如何判断信息是否可信？",
    a: "建议先看信源是否明确，再比对多家口径，最后关注事件是否有后续官宣或实锤。吃瓜可以，但要多方求证，少点情绪上头。",
  },
  {
    q: "榜单上的热度值是怎么算的？",
    a: "热度值由搜索指数、社交平台讨论量、话题阅读与分享量等维度加权综合得出，数值仅反映网络讨论趋势，不代表事件本身的对错与价值。",
  },
];